import type { ActivityPlanUnitItem } from '@linktivity/ars-neo';
import type { UnitCardUnit } from '@link/share/business';

export const getDependentUnitWarningTitle = (units: UnitCardUnit[]): string => {
  const unitsWithQuantity = units.filter(unit => (unit.quantity ?? 0) > 0);
  const dependentUnits = unitsWithQuantity.filter(
    unit => unit.canBeBookingIndepend === false
  );
  const hasIndependentUnits = unitsWithQuantity.some(
    unit => unit.canBeBookingIndepend === true
  );

  if (dependentUnits.length > 0 && !hasIndependentUnits) {
    return dependentUnits[0]?.name || '';
  }

  return '';
};

/**
 * The single home for `-> ActivityPlanUnitItem`. Two input shapes exist because
 * option cards track their units by `unitId`/`count` while the main product
 * tracks the selected units by `id`/`quantity`.
 */
export function unitQuantitiesToPlanUnitItems(
  quantities: Array<{
    unitId: string;
    name: string;
    amount: number;
    displayAmount: number;
    count: number;
  }>
): ActivityPlanUnitItem[] {
  return quantities.map(unit => ({
    unitId: unit.unitId,
    title: unit.name,
    count: unit.count,
    amount: unit.amount,
    displayAmount: unit.displayAmount
  }));
}

/** Selected units of the main product. Unpicked units are not sold. */
export function selectedUnitsToPlanUnitItems(
  units: Array<{
    id?: string;
    name?: string;
    amount?: number;
    displayAmount?: number;
    quantity?: number;
  }>
): ActivityPlanUnitItem[] {
  return units
    .filter(unit => (unit.quantity ?? 0) > 0)
    .map(unit => ({
      unitId: unit.id,
      title: unit.name,
      count: unit.quantity,
      amount: unit.amount,
      displayAmount: unit.displayAmount
    }));
}
